import { styled } from '@mui/material';
export const PreLineBox = styled('div')({
    whiteSpace: 'pre-line',
});
export const TooltipIconHelperContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
}));
